import { useEffect } from "react";
import { useQueryClient } from "react-query";
import useAuth from "hooks/useAuth";
import { invalidateCommentSummaryQueries } from "service/comment.service";
import {
  connectDpatRealtime,
  startDpatCommentsRevisionWatch,
} from "utils/dpatRealtimeQuerySync";

/** Keep React Query comment caches in sync with new CMS data while the sheet is open. */
export function useDpatRealtimeQuerySync(districtId, year) {
  const queryClient = useQueryClient();
  const { user } = useAuth();
  const username = user?.user?.username || "";

  useEffect(() => {
    if (!districtId || year == null || year === "") return undefined;

    let timer = null;
    const refreshFromServer = () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => {
        invalidateCommentSummaryQueries(queryClient, { broadcast: false });
      }, 1500);
    };

    const stopRealtime = connectDpatRealtime({
      districtId,
      year,
      username,
      onInvalidate: refreshFromServer,
    });
    const stopWatch = startDpatCommentsRevisionWatch({
      districtId,
      year,
      onChange: refreshFromServer,
    });

    return () => {
      window.clearTimeout(timer);
      stopWatch?.();
      stopRealtime?.();
    };
  }, [districtId, year, username, queryClient]);
}
